/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function AddPageGroup({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#AddPageGroup_svg__a)"><path fill="currentColor" fillRule="evenodd" d="M11.6 13.1h1.9a2.1 2.1 0 0 0 2.1-2.1V5c0-.015 0-.03-.002-.044a2.1 2.1 0 0 0-.592-1.382l-2.467-2.538A2.1 2.1 0 0 0 11.033.4H6.5a2.1 2.1 0 0 0-2.1 2.1v.65H2.5a2.1 2.1 0 0 0-2.1 2.1v8.5c0 1.16.94 2.1 2.1 2.1h7a2.1 2.1 0 0 0 2.1-2.1v-.65ZM6.5 1.6a.9.9 0 0 0-.9.9v.65h1.433a2.1 2.1 0 0 1 1.506.636l2.467 2.538A2.1 2.1 0 0 1 11.6 7.75v4.15h1.9a.9.9 0 0 0 .9-.9V5.6h-1.733A2.267 2.267 0 0 1 10.4 3.333V1.6H6.5Zm5.1 1.733V1.801a.893.893 0 0 1 .078.072L14.135 4.4h-1.468c-.59 0-1.067-.478-1.067-1.067ZM2.5 4.35a.9.9 0 0 0-.9.9v8.5a.9.9 0 0 0 .9.9h7a.9.9 0 0 0 .9-.9v-5.4H8.667A2.267 2.267 0 0 1 6.4 6.083V4.35H2.5Zm5.178.273A.902.902 0 0 0 7.6 4.55v1.532c0 .59.477 1.067 1.067 1.067h1.468L7.678 4.623Z" clipRule="evenodd" /></g><defs><clipPath id="AddPageGroup_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;